/* Enhance only rendered collection-description text, never HTML attributes or URLs. */
if (!customElements.get('ssb-brand-emphasis')) {
  customElements.define('ssb-brand-emphasis', class extends HTMLElement {
    goldForCanvas(element) {
      const background = [0, 0, 0];
      let opacity = 0;
      for (let current = element; current && opacity < 0.999; current = current.parentElement) {
        const rgb = getComputedStyle(current).backgroundColor.match(/[\d.]+/g)?.map(Number);
        if (!rgb || rgb.length < 3) continue;
        const alpha = (rgb[3] ?? 1) * (1 - opacity);
        background.forEach((value, index) => { background[index] = value + rgb[index] * alpha; });
        opacity += alpha;
      }
      background.forEach((value, index) => { background[index] = value + 255 * (1 - opacity); });
      const luminance = rgb => rgb.reduce((total, value, index) => {
        const channel = value / 255;
        return total + [0.2126, 0.7152, 0.0722][index] * (channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4);
      }, 0);
      const canvas = luminance(background);
      return ['#f2d59b', '#805b17', '#fff1c9', '#2b1c08', '#ffffff', '#000000'].find(color => {
        const ink = luminance([1, 3, 5].map(index => parseInt(color.slice(index, index + 2), 16)));
        return (Math.max(canvas, ink) + 0.05) / (Math.min(canvas, ink) + 0.05) >= 4.5;
      }) || '#2b1c08';
    }
    connectedCallback() {
      const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        if (node.parentElement.closest('script,style,textarea,svg,.ssb-brand-emphasis__name')) return;
        const matches = [...node.textContent.matchAll(/SkinSwaag\s+Beauty/g)];
        if (!matches.length) return;
        const fragment = document.createDocumentFragment();
        let start = 0;
        matches.forEach(match => {
          fragment.append(document.createTextNode(node.textContent.slice(start, match.index)));
          const name = document.createElement('strong');
          name.className = 'ssb-brand-emphasis__name';
          name.style.setProperty('--ssb-brand-gold', this.goldForCanvas(node.parentElement));
          name.append(document.createTextNode(match[0]));
          const glint = document.createElement('span');
          glint.className = 'ssb-brand-emphasis__glint';
          glint.setAttribute('aria-hidden', 'true');
          glint.textContent = ' ✦';
          name.append(glint);
          fragment.append(name);
          start = match.index + match[0].length;
        });
        fragment.append(document.createTextNode(node.textContent.slice(start)));
        node.replaceWith(fragment);
      });
    }
  });
}
